/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PackageFileWithDownloadSchema
 */
export interface PackageFileWithDownloadSchema {
    /**
     * 
     * @type {number}
     * @memberof PackageFileWithDownloadSchema
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PackageFileWithDownloadSchema
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof PackageFileWithDownloadSchema
     */
    downloadUrl?: string;
}

/**
 * Check if a given object implements the PackageFileWithDownloadSchema interface.
 */
export function instanceOfPackageFileWithDownloadSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "fileName" in value;

    return isInstance;
}

export function PackageFileWithDownloadSchemaFromJSON(json: any): PackageFileWithDownloadSchema {
    return PackageFileWithDownloadSchemaFromJSONTyped(json, false);
}

export function PackageFileWithDownloadSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackageFileWithDownloadSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fileName': json['file_name'],
        'downloadUrl': !exists(json, 'download_url') ? undefined : json['download_url'],
    };
}

export function PackageFileWithDownloadSchemaToJSON(value?: PackageFileWithDownloadSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'file_name': value.fileName,
        'download_url': value.downloadUrl,
    };
}

